const productlist = [
  {
    id: 1,
    product_name: "Anardana Powder",
    product_desc:
      "Powdered pomegranate seeds, for preparing colourful and delicious dishes, with a tangy kick. Also used as an after-meal snack to ease heartburn!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "60",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 1,
    PackType: "Classic",
  },
  {
    id: 1,
    product_name: "Anardana Powder",
    product_desc:
      "Powdered pomegranate seeds, for preparing colourful and delicious dishes, with a tangy kick. Also used as an after-meal snack to ease heartburn!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "90",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 2,
    PackType: "Classic",
  },
  {
    id: 2,
    product_name: "Biryani Pulao Masala",
    product_desc:
      "This spice combination is ideal for both veg. and non-veg. variety of pulao. Its unique aroma and taste are bound to cast a spell on you.\n",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 12,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "50",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 3,
    PackType: "Classic",
  },
  {
    id: 2,
    product_name: "Biryani Pulao Masala",
    product_desc:
      "This spice combination is ideal for both veg. and non-veg. variety of pulao. Its unique aroma and taste are bound to cast a spell on you.\n",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 12,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "85",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 4,
    PackType: "Classic",
  },
  {
    id: 3,
    product_name: "Black Pepper Powder",
    product_desc:
      "B.M.C Pepper, the well known name of pure and supreme quality, prepared from Indian Pepper. Thoroughly cleaned and care has been taken to retain its natural taste and original fragrance. It adds flavour to make the dish tastier.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 11,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "95",
    size: "50g",
    pack_type: 2,
    imgUrls: "22b, 22",
    info_id: 5,
    PackType: "Classic",
  },
  {
    id: 3,
    product_name: "Black Pepper Powder",
    product_desc:
      "B.M.C Pepper, the well known name of pure and supreme quality, prepared from Indian Pepper. Thoroughly cleaned and care has been taken to retain its natural taste and original fragrance. It adds flavour to make the dish tastier.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 11,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "175",
    size: "100g",
    pack_type: 2,
    imgUrls: "22b, 22",
    info_id: 6,
    PackType: "Classic",
  },
  {
    id: 4,
    product_name: "Chana Masala",
    product_desc:
      "Takes the regular Chana dish to another level of taste and flavour, demanding another bathura or two to mop up that delicious gravy!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 3,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "39",
    size: "50g",
    pack_type: 2,
    imgUrls: "15b, 15",
    info_id: 7,
    PackType: "Classic",
  },
  {
    id: 4,
    product_name: "Chana Masala",
    product_desc:
      "Takes the regular Chana dish to another level of taste and flavour, demanding another bathura or two to mop up that delicious gravy!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 3,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "60",
    size: "100g",
    pack_type: 2,
    imgUrls: "15b, 15",
    info_id: 8,
    PackType: "Classic",
  },
  {
    id: 4,
    product_name: "Chana Masala",
    product_desc:
      "Takes the regular Chana dish to another level of taste and flavour, demanding another bathura or two to mop up that delicious gravy!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 3,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "293",
    size: "500g",
    pack_type: 2,
    imgUrls: "15b, 15",
    info_id: 9,
    PackType: "Classic",
  },
  {
    id: 5,
    product_name: "Chat Masala",
    product_desc:
      "Delicious masala for preparation of all Chaats (street food) and salads. Makes aloo chaat, pani puris, fruit salad and papri chaat lip-smacking!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 2,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "39",
    size: "50g",
    pack_type: 2,
    imgUrls: "17b, 17",
    info_id: 10,
    PackType: "Classic",
  },
  {
    id: 5,
    product_name: "Chat Masala",
    product_desc:
      "Delicious masala for preparation of all Chaats (street food) and salads. Makes aloo chaat, pani puris, fruit salad and papri chaat lip-smacking!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 2,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "60",
    size: "100g",
    pack_type: 2,
    imgUrls: "17b, 17",
    info_id: 11,
    PackType: "Classic",
  },
  {
    id: 5,
    product_name: "Chat Masala",
    product_desc:
      "Delicious masala for preparation of all Chaats (street food) and salads. Makes aloo chaat, pani puris, fruit salad and papri chaat lip-smacking!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 2,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "293",
    size: "500g",
    pack_type: 2,
    imgUrls: "17b, 17",
    info_id: 12,
    PackType: "Classic",
  },
  {
    id: 6,
    product_name: "Chick Mas",
    product_desc:
      "For all Chicken recipes this singature spice blend comes in handy. Handier than ever, now in a Mini Pack! With BMC Chickmas, you would relish your favourite Chicken dishes more than ever. Tips: Add 20 gms. of Chickmas per kg. of Chicken, following your regular recipes and taste the difference.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 9,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "5",
    size: "NA",
    pack_type: 4,
    imgUrls: "63b, 63",
    info_id: 13,
    PackType: "Mini Pouch",
  },
  {
    id: 6,
    product_name: "Chick Mas",
    product_desc:
      "For all Chicken recipes this singature spice blend comes in handy. Handier than ever, now in a Mini Pack! With BMC Chickmas, you would relish your favourite Chicken dishes more than ever. Tips: Add 20 gms. of Chickmas per kg. of Chicken, following your regular recipes and taste the difference.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 9,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "31",
    size: "25g",
    pack_type: 2,
    imgUrls: "14b, 14",
    info_id: 14,
    PackType: "Classic",
  },
  {
    id: 6,
    product_name: "Chick Mas",
    product_desc:
      "For all Chicken recipes this singature spice blend comes in handy. Handier than ever, now in a Mini Pack! With BMC Chickmas, you would relish your favourite Chicken dishes more than ever. Tips: Add 20 gms. of Chickmas per kg. of Chicken, following your regular recipes and taste the difference.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 9,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "50g",
    pack_type: 2,
    imgUrls: "14b, 14",
    info_id: 15,
    PackType: "Classic",
  },
  {
    id: 6,
    product_name: "Chick Mas",
    product_desc:
      "For all Chicken recipes this singature spice blend comes in handy. Handier than ever, now in a Mini Pack! With BMC Chickmas, you would relish your favourite Chicken dishes more than ever. Tips: Add 20 gms. of Chickmas per kg. of Chicken, following your regular recipes and taste the difference.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 9,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "66",
    size: "100g",
    pack_type: 2,
    imgUrls: "14b, 14",
    info_id: 16,
    PackType: "Classic",
  },
  {
    id: 7,
    product_name: "Chowmein Masala",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 17,
    PackType: "Classic",
  },
  {
    id: 7,
    product_name: "Chowmein Masala",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "66",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 18,
    PackType: "Classic",
  },
  {
    id: 8,
    product_name: "Chutney Podina Powder",
    product_desc:
      "Podina, or mint, brought from lush green kitchen gardens to your kitchen. Makes for delicious podina chutneys to accompany pakoras, and gives a new dimension to raita and sandwiches. A multi-purpose, well-loved and versatile seasoning for all cuisines.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "55",
    size: "100g",
    pack_type: 2,
    imgUrls: "23b, 23",
    info_id: 19,
    PackType: "Classic",
  },
  {
    id: 9,
    product_name: "Curry Powder",
    product_desc:
      "All purpose spice blend used commonly to flavor soups, stews, sauces, marinades, meat, and vegetables",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "37",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 20,
    PackType: "Classic",
  },
  {
    id: 9,
    product_name: "Curry Powder",
    product_desc:
      "All purpose spice blend used commonly to flavor soups, stews, sauces, marinades, meat, and vegetables",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "57",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 21,
    PackType: "Classic",
  },
  {
    id: 9,
    product_name: "Curry Powder",
    product_desc:
      "All purpose spice blend used commonly to flavor soups, stews, sauces, marinades, meat, and vegetables",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "112",
    size: "200g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 22,
    PackType: "Classic",
  },
  {
    id: 10,
    product_name: "Dhania Powder",
    product_desc:
      "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "5",
    size: "NA",
    pack_type: 4,
    imgUrls: "61b, 61",
    info_id: 23,
    PackType: "Mini Pouch",
  },
  {
    id: 10,
    product_name: "Dhania Powder",
    product_desc:
      "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "10",
    size: "20g",
    pack_type: 1,
    imgUrls: "61b, 61",
    info_id: 24,
    PackType: "Pouch",
  },
  {
    id: 10,
    product_name: "Dhania Powder",
    product_desc:
      "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "16",
    size: "50g",
    pack_type: 1,
    imgUrls: "56b, 56",
    info_id: 25,
    PackType: "Pouch",
  },
  {
    id: 10,
    product_name: "Dhania Powder",
    product_desc:
      "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "34",
    size: "100g",
    pack_type: 2,
    imgUrls: "56b, 56",
    info_id: 26,
    PackType: "Classic",
  },
  {
    id: 10,
    product_name: "Dhania Powder",
    product_desc:
      "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "32",
    size: "100g",
    pack_type: 1,
    imgUrls: "56b, 56",
    info_id: 27,
    PackType: "Pouch",
  },
  {
    id: 10,
    product_name: "Dhania Powder",
    product_desc:
      "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "64",
    size: "200g",
    pack_type: 1,
    imgUrls: "56b, 56",
    info_id: 28,
    PackType: "Pouch",
  },
  {
    id: 10,
    product_name: "Dhania Powder",
    product_desc:
      "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "158",
    size: "500g",
    pack_type: 2,
    imgUrls: "56b, 56",
    info_id: 29,
    PackType: "Classic",
  },
  {
    id: 10,
    product_name: "Dhania Powder",
    product_desc:
      "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "313",
    size: "1 Kg",
    pack_type: 3,
    imgUrls: "56b, 56",
    info_id: 30,
    PackType: "For Hotels",
  },
  {
    id: 10,
    product_name: "Dhania Powder",
    product_desc:
      "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "1530",
    size: "5 Kg",
    pack_type: 3,
    imgUrls: "56b, 56",
    info_id: 31,
    PackType: "For Hotels",
  },
  {
    id: 11,
    product_name: "Debbi Mirch",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "60",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 32,
    PackType: "Classic",
  },
  {
    id: 12,
    product_name: "Dry Mango Powder (Amchoor)",
    product_desc:
      "Amchoor Masala or dried, powdered mango is a pantry staple across Indian households, for daily preparations of all lip-smacking street foods, and adding that zing to achaars (pickles).",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "36",
    size: "50g",
    pack_type: 2,
    imgUrls: "16b, 16",
    info_id: 33,
    PackType: "Classic",
  },
  {
    id: 12,
    product_name: "Dry Mango Powder (Amchoor)",
    product_desc:
      "Amchoor Masala or dried, powdered mango is a pantry staple across Indian households, for daily preparations of all lip-smacking street foods, and adding that zing to achaars (pickles).",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "60",
    size: "100g",
    pack_type: 2,
    imgUrls: "16b, 16",
    info_id: 34,
    PackType: "Classic",
  },
  {
    id: 12,
    product_name: "Dry Mango Powder (Amchoor)",
    product_desc:
      "Amchoor Masala or dried, powdered mango is a pantry staple across Indian households, for daily preparations of all lip-smacking street foods, and adding that zing to achaars (pickles).",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "352",
    size: "500g",
    pack_type: 2,
    imgUrls: "16b, 16",
    info_id: 35,
    PackType: "Classic",
  },
  {
    id: 13,
    product_name: "Dalchini Powder",
    product_desc:
      "Finest ground cinnamon; easy to add to tea, marinades and gravy dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "30",
    size: "50g",
    pack_type: 2,
    imgUrls: "26b, 26",
    info_id: 36,
    PackType: "Classic",
  },
  {
    id: 14,
    product_name: "Elaichi Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "NA",
    size: "15g",
    pack_type: 4,
    imgUrls: "null",
    info_id: 37,
    PackType: "Mini Pouch",
  },
  {
    id: 14,
    product_name: "Elaichi Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "43",
    size: "25g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 38,
    PackType: "Classic",
  },
  {
    id: 15,
    product_name: "Fish Masala",
    product_desc:
      "High quality spice rub for those delicious pan-fried and oven-baked fish dishes. Essential for excellent, fragrant marinades too.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 10,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "5",
    size: "NA",
    pack_type: 4,
    imgUrls: "59b, 59",
    info_id: 39,
    PackType: "Mini Pouch",
  },
  {
    id: 15,
    product_name: "Fish Masala",
    product_desc:
      "High quality spice rub for those delicious pan-fried and oven-baked fish dishes. Essential for excellent, fragrant marinades too.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 10,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "37",
    size: "50g",
    pack_type: 2,
    imgUrls: "24b, 24",
    info_id: 40,
    PackType: "Classic",
  },
  {
    id: 15,
    product_name: "Fish Masala",
    product_desc:
      "High quality spice rub for those delicious pan-fried and oven-baked fish dishes. Essential for excellent, fragrant marinades too.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 10,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "57",
    size: "100g",
    pack_type: 2,
    imgUrls: "24b, 24",
    info_id: 41,
    PackType: "Classic",
  },
  {
    id: 16,
    product_name: "Garam Masala",
    product_desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations.\n\nA mixture of many masalas, Garam masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 4,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "NA",
    size: "NA",
    pack_type: 4,
    imgUrls: "7b, 7",
    info_id: 42,
    PackType: "Mini Pouch",
  },
  {
    id: 16,
    product_name: "Garam Masala",
    product_desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations.\n\nA mixture of many masalas, Garam masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 4,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "32",
    size: "25g",
    pack_type: 2,
    imgUrls: "7b, 7",
    info_id: 43,
    PackType: "Classic",
  },
  {
    id: 16,
    product_name: "Garam Masala",
    product_desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations.\n\nA mixture of many masalas, Garam masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 4,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "42",
    size: "50g",
    pack_type: 2,
    imgUrls: "7b, 7",
    info_id: 44,
    PackType: "Classic",
  },
  {
    id: 16,
    product_name: "Garam Masala",
    product_desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations.\n\nA mixture of many masalas, Garam masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 4,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "72",
    size: "100g",
    pack_type: 2,
    imgUrls: "7b, 7",
    info_id: 45,
    PackType: "Classic",
  },
  {
    id: 16,
    product_name: "Garam Masala",
    product_desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations.\n\nA mixture of many masalas, Garam masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 4,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "353",
    size: "500g",
    pack_type: 2,
    imgUrls: "7b, 7",
    info_id: 46,
    PackType: "Classic",
  },
  {
    id: 17,
    product_name: "Ginger Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 47,
    PackType: "Classic",
  },
  {
    id: 17,
    product_name: "Ginger Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "70",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 48,
    PackType: "Classic",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "5",
    size: "NA",
    pack_type: 4,
    imgUrls: "64b, 64",
    info_id: 49,
    PackType: "Mini Pouch",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "10",
    size: "30g",
    pack_type: 1,
    imgUrls: "64b, 64",
    info_id: 50,
    PackType: "Pouch",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "18",
    size: "50g",
    pack_type: 2,
    imgUrls: "13b, 13",
    info_id: 51,
    PackType: "Classic",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "35",
    size: "100g",
    pack_type: 2,
    imgUrls: "13b, 13",
    info_id: 52,
    PackType: "Classic",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "68",
    size: "200g",
    pack_type: 2,
    imgUrls: "13b, 13",
    info_id: 53,
    PackType: "Classic",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "17",
    size: "50g",
    pack_type: 1,
    imgUrls: "13b, 13",
    info_id: 54,
    PackType: "Pouch",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "33",
    size: "100g",
    pack_type: 1,
    imgUrls: "13b, 13",
    info_id: 55,
    PackType: "Pouch",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "65",
    size: "200g",
    pack_type: 1,
    imgUrls: "13b, 13",
    info_id: 56,
    PackType: "Pouch",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "163",
    size: "500g",
    pack_type: 2,
    imgUrls: "13b, 13",
    info_id: 57,
    PackType: "Classic",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "322",
    size: "1 Kg",
    pack_type: 3,
    imgUrls: "13b, 13",
    info_id: 58,
    PackType: "For Hotels",
  },
  {
    id: 18,
    product_name: "Haldi Powder",
    product_desc:
      "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "1575",
    size: "5 Kg",
    pack_type: 3,
    imgUrls: "13b, 13",
    info_id: 59,
    PackType: "For Hotels",
  },
  {
    id: 19,
    product_name: "Hing Compound",
    product_desc:
      "Asafoetida powder adds a spicy kick to the silky, smooth base of Indian daals, curries and street food, while supporting digestive health. ",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "NA",
    size: "10g",
    pack_type: 4,
    imgUrls: "42b, 42",
    info_id: 60,
    PackType: "Mini Pouch",
  },
  {
    id: 19,
    product_name: "Hing Compound",
    product_desc:
      "Asafoetida powder adds a spicy kick to the silky, smooth base of Indian daals, curries and street food, while supporting digestive health. ",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "30",
    size: "25g",
    pack_type: 2,
    imgUrls: "42b, 42",
    info_id: 61,
    PackType: "Classic",
  },
  {
    id: 20,
    product_name: "Jal Jeera",
    product_desc:
      "Traditional recipe for refreshing, cold glasses of Jal Jeera. Jal Jeera is a drink that may be called the Indian version of the lemonade. And just like the lemonade it makes for a great cold drink in summer. And what better way to prepare it, than to just take a glass of water and add a spoonful of BMC Jal Jeera Powder. And the cooling effect is because of special herbs that go into the preparation of the BMC Jal Jeera Powder. Also a delicious addition to any cold drinks!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "33",
    size: "50g",
    pack_type: 2,
    imgUrls: "6b, 6",
    info_id: 62,
    PackType: "Classic",
  },
  {
    id: 20,
    product_name: "Jal Jeera",
    product_desc:
      "Traditional recipe for refreshing, cold glasses of Jal Jeera. Jal Jeera is a drink that may be called the Indian version of the lemonade. And just like the lemonade it makes for a great cold drink in summer. And what better way to prepare it, than to just take a glass of water and add a spoonful of BMC Jal Jeera Powder. And the cooling effect is because of special herbs that go into the preparation of the BMC Jal Jeera Powder. Also a delicious addition to any cold drinks!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "52",
    size: "100g",
    pack_type: 2,
    imgUrls: "6b, 6",
    info_id: 63,
    PackType: "Classic",
  },
  {
    id: 21,
    product_name: "Kashmiri Mirch Powder",
    product_desc: "Chilli powder makes dishes delicious and colourful!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 8,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "39",
    size: "50g",
    pack_type: 2,
    imgUrls: "31b, 31",
    info_id: 64,
    PackType: "Classic",
  },
  {
    id: 21,
    product_name: "Kashmiri Mirch Powder",
    product_desc: "Chilli powder makes dishes delicious and colourful!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 8,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "60",
    size: "100g",
    pack_type: 2,
    imgUrls: "31b, 31",
    info_id: 65,
    PackType: "Classic",
  },
  {
    id: 21,
    product_name: "Kashmiri Mirch Powder",
    product_desc: "Chilli powder makes dishes delicious and colourful!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 8,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "293",
    size: "500g",
    pack_type: 2,
    imgUrls: "31b, 31",
    info_id: 66,
    PackType: "Classic",
  },
  {
    id: 22,
    product_name: "Kasoori Methi Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 6,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "25",
    size: "25g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 67,
    PackType: "Classic",
  },
  {
    id: 22,
    product_name: "Kasoori Methi Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 6,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "46",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 68,
    PackType: "Classic",
  },
  {
    id: 22,
    product_name: "Kasoori Methi Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 6,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "82",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 69,
    PackType: "Classic",
  },
  {
    id: 22,
    product_name: "Kasoori Methi Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 6,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "164",
    size: "250g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 70,
    PackType: "Classic",
  },
  {
    id: 22,
    product_name: "Kasoori Methi Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 6,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "322",
    size: "500g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 71,
    PackType: "Classic",
  },
  {
    id: 23,
    product_name: "Kitchen King",
    product_desc:
      "The right mix of a number of special Masalas to bring out unparalleled taste in all vegetarian dishes. This multi-use spice-mix is an essential commodity for a kitchen where treats are a routine. \nTips: Follow your usual cooking method and add 20 gms. of BMC Kitchen KIng to 1kg. veg. (or in right proportion) mixing it thoroughly. No other spices required.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 5,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "5",
    size: "NA",
    pack_type: 4,
    imgUrls: "70b, 70",
    info_id: 72,
    PackType: "Mini Pouch",
  },
  {
    id: 23,
    product_name: "Kitchen King",
    product_desc:
      "The right mix of a number of special Masalas to bring out unparalleled taste in all vegetarian dishes. This multi-use spice-mix is an essential commodity for a kitchen where treats are a routine. \nTips: Follow your usual cooking method and add 20 gms. of BMC Kitchen KIng to 1kg. veg. (or in right proportion) mixing it thoroughly. No other spices required.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 5,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "50g",
    pack_type: 2,
    imgUrls: "2b, 2",
    info_id: 73,
    PackType: "Classic",
  },
  {
    id: 23,
    product_name: "Kitchen King",
    product_desc:
      "The right mix of a number of special Masalas to bring out unparalleled taste in all vegetarian dishes. This multi-use spice-mix is an essential commodity for a kitchen where treats are a routine. \nTips: Follow your usual cooking method and add 20 gms. of BMC Kitchen KIng to 1kg. veg. (or in right proportion) mixing it thoroughly. No other spices required.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 5,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "66",
    size: "100g",
    pack_type: 2,
    imgUrls: "2b, 2",
    info_id: 74,
    PackType: "Classic",
  },
  {
    id: 24,
    product_name: "Metmas ",
    product_desc:
      "Surprise your family & friends with exotic non-veg delicacies such as Mutton, Korma (Shahi) or Keema etc. by adding a little Metmas. Give the cuisine the exclusive colour and flavour. Signature spice blend, with saffron.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 7,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "5",
    size: "NA",
    pack_type: 4,
    imgUrls: "67b, 67",
    info_id: 75,
    PackType: "Mini Pouch",
  },
  {
    id: 24,
    product_name: "Metmas ",
    product_desc:
      "Surprise your family & friends with exotic non-veg delicacies such as Mutton, Korma (Shahi) or Keema etc. by adding a little Metmas. Give the cuisine the exclusive colour and flavour. Signature spice blend, with saffron.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 7,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "50g",
    pack_type: 2,
    imgUrls: "9b, 9",
    info_id: 76,
    PackType: "Classic",
  },
  {
    id: 24,
    product_name: "Metmas ",
    product_desc:
      "Surprise your family & friends with exotic non-veg delicacies such as Mutton, Korma (Shahi) or Keema etc. by adding a little Metmas. Give the cuisine the exclusive colour and flavour. Signature spice blend, with saffron.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 7,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "66",
    size: "100g",
    pack_type: 2,
    imgUrls: "9b, 9",
    info_id: 77,
    PackType: "Classic",
  },
  {
    id: 25,
    product_name: "Mirch Kutti",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "42",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 78,
    PackType: "Classic",
  },
  {
    id: 25,
    product_name: "Mirch Kutti",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "208",
    size: "500g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 79,
    PackType: "Classic",
  },
  {
    id: 26,
    product_name: "Mirch Powder",
    product_desc:
      "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "10",
    size: "30g",
    pack_type: 1,
    imgUrls: "65b, 65",
    info_id: 80,
    PackType: "Pouch",
  },
  {
    id: 26,
    product_name: "Mirch Powder",
    product_desc:
      "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "18",
    size: "50g",
    pack_type: 1,
    imgUrls: "58b, 58",
    info_id: 81,
    PackType: "Pouch",
  },
  {
    id: 26,
    product_name: "Mirch Powder",
    product_desc:
      "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "37",
    size: "100g",
    pack_type: 2,
    imgUrls: "58b, 58",
    info_id: 82,
    PackType: "Classic",
  },
  {
    id: 26,
    product_name: "Mirch Powder",
    product_desc:
      "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "35",
    size: "100g",
    pack_type: 1,
    imgUrls: "58b, 58",
    info_id: 83,
    PackType: "Pouch",
  },
  {
    id: 26,
    product_name: "Mirch Powder",
    product_desc:
      "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "69",
    size: "200g",
    pack_type: 1,
    imgUrls: "58b, 58",
    info_id: 84,
    PackType: "Pouch",
  },
  {
    id: 26,
    product_name: "Mirch Powder",
    product_desc:
      "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "173",
    size: "500g",
    pack_type: 2,
    imgUrls: "58b, 58",
    info_id: 85,
    PackType: "Classic",
  },
  {
    id: 26,
    product_name: "Mirch Powder",
    product_desc:
      "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "345",
    size: "1 Kg",
    pack_type: 3,
    imgUrls: "58b, 58",
    info_id: 86,
    PackType: "For Hotels",
  },
  {
    id: 26,
    product_name: "Mirch Powder",
    product_desc:
      "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "1685",
    size: "5 Kg",
    pack_type: 3,
    imgUrls: "58b, 58",
    info_id: 87,
    PackType: "For Hotels",
  },
  {
    id: 27,
    product_name: "Mohini Garam Masala",
    product_desc:
      "Discover the gourmet in you with the BMC Mohini Garam Masala. Made from fresh Indian Spices, it is the right mix of spices that enhances the taste of veg. & non-veg. dishes alike.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "42",
    size: "50g",
    pack_type: 2,
    imgUrls: "29b, 29",
    info_id: 88,
    PackType: "Classic",
  },
  {
    id: 27,
    product_name: "Mohini Garam Masala",
    product_desc:
      "Discover the gourmet in you with the BMC Mohini Garam Masala. Made from fresh Indian Spices, it is the right mix of spices that enhances the taste of veg. & non-veg. dishes alike.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "72",
    size: "100g",
    pack_type: 2,
    imgUrls: "29b, 29",
    info_id: 89,
    PackType: "Classic",
  },
  {
    id: 28,
    product_name: "MoMo Masala",
    product_desc:
      "Makes delicious lip-smacking and authentic momos, with all the zingy flavour from the street-side stalls!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "50g",
    pack_type: 2,
    imgUrls: "8b, 8",
    info_id: 90,
    PackType: "Classic",
  },
  {
    id: 28,
    product_name: "MoMo Masala",
    product_desc:
      "Makes delicious lip-smacking and authentic momos, with all the zingy flavour from the street-side stalls!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "66",
    size: "100g",
    pack_type: 2,
    imgUrls: "8b, 8",
    info_id: 91,
    PackType: "Classic",
  },
  {
    id: 29,
    product_name: "Mutton Masala",
    product_desc:
      "Beautiful spices that make for melt-in-the-mouth mutton dishes. This Masala can be used in 4 Kg of Meat.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "66",
    size: "100g",
    pack_type: 2,
    imgUrls: "35b, 35",
    info_id: 92,
    PackType: "Classic",
  },
  {
    id: 30,
    product_name: "Pav Bhaji Masala",
    product_desc:
      "Adds lip-smacking flavour to homemade Pav Bhaji, making buttery pavs and crunch veggies sing!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "36",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 93,
    PackType: "Classic",
  },
  {
    id: 30,
    product_name: "Pav Bhaji Masala",
    product_desc:
      "Adds lip-smacking flavour to homemade Pav Bhaji, making buttery pavs and crunch veggies sing!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "58",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 94,
    PackType: "Classic",
  },
  {
    id: 31,
    product_name: "Pudina Patta",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "33",
    size: "25g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 95,
    PackType: "Classic",
  },
  {
    id: 32,
    product_name: "Pani Puri Masala",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "33",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 96,
    PackType: "Classic",
  },
  {
    id: 32,
    product_name: "Pani Puri Masala",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "52",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 97,
    PackType: "Classic",
  },
  {
    id: 33,
    product_name: "Pulao Masala",
    product_desc:
      "Spices that create the fragrant, heart-warming rice dishes fit for a king, in your own kitchen. High quality mix that brings convenience to tradition.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "85",
    size: "100g",
    pack_type: 2,
    imgUrls: "19b, 19",
    info_id: 98,
    PackType: "Classic",
  },
  {
    id: 34,
    product_name: "Rai Powder",
    product_desc:
      "Powdererd mustard seeds, that add warmth and distinct flavour to most Indian dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "52",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 99,
    PackType: "Classic",
  },
  {
    id: 35,
    product_name: "Rayta Masala",
    product_desc:
      "Spice up the regular, boring yogurt with the BMC Rayta Masala, and it will be an instant hit.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "57",
    size: "100g",
    pack_type: 2,
    imgUrls: "20b, 20",
    info_id: 100,
    PackType: "Classic",
  },
  {
    id: 36,
    product_name: "Roghni Mirch Powder",
    product_desc: "Chilli powder makes dishes delicious and colourful!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "39",
    size: "50g",
    pack_type: 2,
    imgUrls: "30b, 30",
    info_id: 101,
    PackType: "Classic",
  },
  {
    id: 36,
    product_name: "Roghni Mirch Powder",
    product_desc: "Chilli powder makes dishes delicious and colourful!",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "60",
    size: "100g",
    pack_type: 2,
    imgUrls: "30b, 30",
    info_id: 102,
    PackType: "Classic",
  },
  {
    id: 37,
    product_name: "Samber Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "36",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 103,
    PackType: "Classic",
  },
  {
    id: 37,
    product_name: "Samber Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "57",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 104,
    PackType: "Classic",
  },
  {
    id: 38,
    product_name: "Sounf Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "26",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 105,
    PackType: "Classic",
  },
  {
    id: 38,
    product_name: "Sounf Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "50",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 106,
    PackType: "Classic",
  },
  {
    id: 39,
    product_name: "Special Meat Masala",
    product_desc:
      "It's the informed choice of those who don't like to waste the precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen.Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 1,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "5",
    size: "NA",
    pack_type: 4,
    imgUrls: "null",
    info_id: 107,
    PackType: "Mini Pouch",
  },
  {
    id: 39,
    product_name: "Special Meat Masala",
    product_desc:
      "It's the informed choice of those who don't like to waste the precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen.Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 1,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "31",
    size: "25g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 108,
    PackType: "Classic",
  },
  {
    id: 39,
    product_name: "Special Meat Masala",
    product_desc:
      "It's the informed choice of those who don't like to waste the precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen.Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 1,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 109,
    PackType: "Classic",
  },
  {
    id: 39,
    product_name: "Special Meat Masala",
    product_desc:
      "It's the informed choice of those who don't like to waste the precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen.Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 1,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "66",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 110,
    PackType: "Classic",
  },
  {
    id: 39,
    product_name: "Special Meat Masala",
    product_desc:
      "It's the informed choice of those who don't like to waste the precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen.Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 1,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "130",
    size: "200g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 111,
    PackType: "Classic",
  },
  {
    id: 39,
    product_name: "Special Meat Masala",
    product_desc:
      "It's the informed choice of those who don't like to waste the precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen.Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 1,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "322",
    size: "500g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 112,
    PackType: "Classic",
  },
  {
    id: 40,
    product_name: "Special Rajmah Masala",
    product_desc:
      "Spice blend from the traditional recipe, that makes for the tastiest Rajma, reminiscent of home cooking and food made by moms and gradmothers. ",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "36",
    size: "50g",
    pack_type: 2,
    imgUrls: "18b, 18",
    info_id: 113,
    PackType: "Classic",
  },
  {
    id: 40,
    product_name: "Special Rajmah Masala",
    product_desc:
      "Spice blend from the traditional recipe, that makes for the tastiest Rajma, reminiscent of home cooking and food made by moms and gradmothers. ",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "58",
    size: "100g",
    pack_type: 2,
    imgUrls: "18b, 18",
    info_id: 114,
    PackType: "Classic",
  },
  {
    id: 41,
    product_name: "Sabzi Masala",
    product_desc:
      "Spices up all vegetable preparations and makes everyday Indian home food extraordinary.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "32",
    size: "50g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 115,
    PackType: "Classic",
  },
  {
    id: 41,
    product_name: "Sabzi Masala",
    product_desc:
      "Spices up all vegetable preparations and makes everyday Indian home food extraordinary.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "52",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 116,
    PackType: "Classic",
  },
  {
    id: 42,
    product_name: "Shahi Paneer Masala",
    product_desc:
      "Masala that makes for a royal, rich and fragrant traditional Paneer dish.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "76",
    size: "100g",
    pack_type: 2,
    imgUrls: "28b, 28",
    info_id: 117,
    PackType: "Classic",
  },
  {
    id: 43,
    product_name: "Tandoori Chicken Masala",
    product_desc:
      "Essential for a rich and spicy base to homemade Tandoori Chicken, the signature delicious Punjabi dish, traditionally made in clay ovens (tandoors)",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "50g",
    pack_type: 2,
    imgUrls: "25b, 25",
    info_id: 118,
    PackType: "Classic",
  },
  {
    id: 43,
    product_name: "Tandoori Chicken Masala",
    product_desc:
      "Essential for a rich and spicy base to homemade Tandoori Chicken, the signature delicious Punjabi dish, traditionally made in clay ovens (tandoors)",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "66",
    size: "100g",
    pack_type: 2,
    imgUrls: "25b, 25",
    info_id: 119,
    PackType: "Classic",
  },
  {
    id: 44,
    product_name: "Teamas",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "49",
    size: "25g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 120,
    PackType: "Classic",
  },
  {
    id: 45,
    product_name: "White Pepper Powder",
    product_desc:
      "White pepper is made from fully ripe pepper berries, adding a sharp bite to silky soups and Chinese gravies. ",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "135",
    size: "50g",
    pack_type: 2,
    imgUrls: "37b, 37",
    info_id: 121,
    PackType: "Classic",
  },
  {
    id: 45,
    product_name: "White Pepper Powder",
    product_desc:
      "White pepper is made from fully ripe pepper berries, adding a sharp bite to silky soups and Chinese gravies. ",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "250",
    size: "100g",
    pack_type: 2,
    imgUrls: "37b, 37",
    info_id: 122,
    PackType: "Classic",
  },
  {
    id: 46,
    product_name: "Yellow Chilli Powder",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "70",
    size: "100g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 123,
    PackType: "Classic",
  },
  {
    id: 47,
    product_name: "Zeera Powder",
    product_desc:
      "Powdered cumin adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "5",
    size: "NA",
    pack_type: 4,
    imgUrls: "66b, 66",
    info_id: 124,
    PackType: "Mini Pouch",
  },
  {
    id: 47,
    product_name: "Zeera Powder",
    product_desc:
      "Powdered cumin adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "34",
    size: "50g",
    pack_type: 1,
    imgUrls: "66b, 66",
    info_id: 125,
    PackType: "Pouch",
  },
  {
    id: 47,
    product_name: "Zeera Powder",
    product_desc:
      "Powdered cumin adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "50g",
    pack_type: 1,
    imgUrls: "66b, 66",
    info_id: 126,
    PackType: "Pouch",
  },
  {
    id: 47,
    product_name: "Zeera Powder",
    product_desc:
      "Powdered cumin adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "65",
    size: "100g",
    pack_type: 2,
    imgUrls: "66b, 66",
    info_id: 127,
    PackType: "Classic",
  },
  {
    id: 47,
    product_name: "Zeera Powder",
    product_desc:
      "Powdered cumin adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "65",
    size: "100g",
    pack_type: 1,
    imgUrls: "66b, 66",
    info_id: 128,
    PackType: "Pouch",
  },
  {
    id: 47,
    product_name: "Zeera Powder",
    product_desc:
      "Powdered cumin adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "319",
    size: "500g",
    pack_type: 2,
    imgUrls: "66b, 66",
    info_id: 129,
    PackType: "Classic",
  },
  {
    id: 48,
    product_name: "Zeera Whole",
    product_desc:
      "Whole cumin that adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "60",
    size: "100g",
    pack_type: 1,
    imgUrls: "62b, 62",
    info_id: 130,
    PackType: "Pouch",
  },
  {
    id: 48,
    product_name: "Zeera Whole",
    product_desc:
      "Whole cumin that adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "298",
    size: "500g",
    pack_type: 2,
    imgUrls: "62b, 62",
    info_id: 131,
    PackType: "Classic",
  },
  {
    id: 49,
    product_name: "Black Salt",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "10",
    size: "100g",
    pack_type: 1,
    imgUrls: "null",
    info_id: 132,
    PackType: "Pouch",
  },
  {
    id: 49,
    product_name: "Black Salt",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "20",
    size: "250g",
    pack_type: 1,
    imgUrls: "null",
    info_id: 133,
    PackType: "Pouch",
  },
  {
    id: 50,
    product_name: "Rock Salt",
    product_desc:
      "Known as Sendha Namak in Hindi, this is coarse, large grained salt ground for easy consumption. Rock Salt has many health benefits, and is a a kitchen staple, especially for use during religious oberservances and fasts, as it is unrefined and non-iodised.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "10",
    size: "100g",
    pack_type: 1,
    imgUrls: "54b, 54",
    info_id: 134,
    PackType: "Pouch",
  },
  {
    id: 50,
    product_name: "Rock Salt",
    product_desc:
      "Known as Sendha Namak in Hindi, this is coarse, large grained salt ground for easy consumption. Rock Salt has many health benefits, and is a a kitchen staple, especially for use during religious oberservances and fasts, as it is unrefined and non-iodised.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r\r",
    created_at: null,
    updated_at: null,
    MRP: "20",
    size: "250g",
    pack_type: 1,
    imgUrls: "54b, 54",
    info_id: 135,
    PackType: "Pouch",
  },
  {
    id: 51,
    product_name: "Ajowain",
    product_desc:
      "Traditional Indian households ‘Ajowan’, or ‘Ajwain’ forms an essential part of health preserving measures, as mush as for a rare taste and flavour in special delicacies. Ajowan is popularly believed to be useful to combat stomach and general ailments and is helpful for digestion. ",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Spices",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "57",
    size: "100g",
    pack_type: 1,
    imgUrls: "null",
    info_id: 136,
    PackType: "Pouch",
  },
  {
    id: 52,
    product_name: "Soya Dish (Badiyan)",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Misc",
    uses: "",
    priority: 0,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "28",
    size: "100g",
    pack_type: 2,
    imgUrls: "21b, 21",
    info_id: 137,
    PackType: "Classic",
  },
  {
    id: 52,
    product_name: "Soya Dish (Badiyan)",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Misc",
    uses: "",
    priority: 0,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "200g",
    pack_type: 2,
    imgUrls: "21b, 21",
    info_id: 138,
    PackType: "Classic",
  },
  {
    id: 53,
    product_name: "Soya Dish (Chura)",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Misc",
    uses: "",
    priority: 0,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "42",
    size: "200g",
    pack_type: 2,
    imgUrls: "21b, 21",
    info_id: 139,
    PackType: "Classic",
  },
  {
    id: 54,
    product_name: "Soya Dish (Mini Chunks)",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Misc",
    uses: "",
    priority: 0,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "28",
    size: "100g",
    pack_type: 2,
    imgUrls: "21b, 21",
    info_id: 140,
    PackType: "Classic",
  },
  {
    id: 54,
    product_name: "Soya Dish (Mini Chunks)",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Misc",
    uses: "",
    priority: 0,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "40",
    size: "200g",
    pack_type: 2,
    imgUrls: "21b, 21",
    info_id: 141,
    PackType: "Classic",
  },
  {
    id: 55,
    product_name: "Taste-N-Taste",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Misc",
    uses: "",
    priority: 0,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "30",
    size: "25g",
    pack_type: 2,
    imgUrls: "27b, 27",
    info_id: 142,
    PackType: "Classic",
  },
  {
    id: 56,
    product_name: "Wheat Daliya",
    product_desc: "",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Misc",
    uses: "",
    priority: 0,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "25",
    size: "300g",
    pack_type: 2,
    imgUrls: "null",
    info_id: 143,
    PackType: "Classic",
  },
  {
    id: 57,
    product_name: "Mala Incense",
    product_desc:
      "Serene yet long lasting fragrance that linger on long after being used! Seven in one. ",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "15",
    size: "35 sticks",
    pack_type: 2,
    imgUrls: "41b, 40",
    info_id: 144,
    PackType: "Classic",
  },
  {
    id: 58,
    product_name: "Special Havan Samagri(M)",
    product_desc:
      "Bawa Havan Samagri and special fragrances in various forms add the ambience to any religious ceremony or godly persuit. Special ingredients to purify purify air and bring happiness. Must have for all sacred occasions",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "28",
    size: "200g",
    pack_type: 2,
    imgUrls: "38b, 38",
    info_id: 145,
    PackType: "Classic",
  },
  {
    id: 59,
    product_name: "Special Havan Samagri(L)",
    product_desc:
      "Bawa Havan Samagri and special fragrances in various forms add the ambience to any religious ceremony or godly persuit. Special ingredients to purify purify air and bring happiness. Must have for all sacred occasions",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "38",
    size: "500g",
    pack_type: 2,
    imgUrls: "38b, 38",
    info_id: 146,
    PackType: "Classic",
  },
  {
    id: 60,
    product_name: "Puja Dhoop - Golden Pack.",
    product_desc: "Golden Pack.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "8",
    size: "30g",
    pack_type: 2,
    imgUrls: "50b, 50",
    info_id: 147,
    PackType: "Classic",
  },
  {
    id: 61,
    product_name: "Puja Dhoop",
    product_desc: "Normal Pack",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "7",
    size: "30g",
    pack_type: 2,
    imgUrls: "52b, 52",
    info_id: 148,
    PackType: "Classic",
  },
  {
    id: 62,
    product_name: "Gulpham Gulab Incense Sticks",
    product_desc:
      "Serene yet long lasting fragrance that linger on long after being used! 20 sticks",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "13",
    size: "20 sticks",
    pack_type: 2,
    imgUrls: "48b, 48",
    info_id: 149,
    PackType: "Classic",
  },
  {
    id: 63,
    product_name: "Mala Incense -  Three in One",
    product_desc: "A Distinguished Incense. Three in One. 15 Sticks",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "12",
    size: "25 sticks",
    pack_type: 2,
    imgUrls: "45b, 45",
    info_id: 150,
    PackType: "Classic",
  },
  {
    id: 64,
    product_name: "Mala Incense - Five In one",
    product_desc: "A Distinguished Incense. Five in One. ",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "12",
    size: "7 Sticks",
    pack_type: 2,
    imgUrls: "47b, 47",
    info_id: 151,
    PackType: "Classic",
  },
  {
    id: 65,
    product_name: "Special Havan Samagri(S)",
    product_desc:
      "Bawa Havan Samagri and special fragrances in various forms add the ambience to any religious ceremony or godly persuit. Special ingredients to purify purify air and bring happiness. Must have for all sacred occasions",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "15",
    size: "100g",
    pack_type: 2,
    imgUrls: "38b, 38",
    info_id: 152,
    PackType: "Classic",
  },
  {
    id: 66,
    product_name: "Mist Incense Sticks",
    product_desc:
      "Serene yet long lasting fragrance that linger on long after being used! Seven in one.",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "15",
    size: "20 Sticks",
    pack_type: 2,
    imgUrls: "49b, 49",
    info_id: 153,
    PackType: "Classic",
  },
  {
    id: 67,
    product_name: "Mala",
    product_desc: "A Distinguished Incense. Three in One. 15 Sticks",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null\r",
    created_at: null,
    updated_at: null,
    MRP: "10",
    size: "15 Sticks",
    pack_type: 2,
    imgUrls: "40b, 40",
    info_id: 154,
    PackType: "Classic",
  },
  {
    id: 68,
    product_name: "Four-in-one Dhoop",
    product_desc: "A Distinguished Incense. Three in One. 15 Sticks",
    recipes_id: "",
    feature: "",
    ingredients: "",
    type_id: "Dhoop",
    uses: "",
    priority: 999,
    TM: "null",
    created_at: null,
    updated_at: null,
    MRP: "17",
    size: "16 sticks",
    pack_type: 2,
    imgUrls: "39b, 39",
    info_id: 155,
    PackType: "Classic",
  },
];

export default productlist;



// WEBPACK FOOTER //
// ./src/Constants/projectList.js